import { render, staticRenderFns } from "./Wechatfiles.vue?vue&type=template&id=a928f7b4"
import script from "./Wechatfiles.vue?vue&type=script&lang=js"
export * from "./Wechatfiles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports